<template>
    <div>
        <question :text="$t(item.text, privacyPolicyLink)" />
        <b-row>
          <b-col cols="12" sm="10" md="8">
                <div class="num-input-item__text-input">
                    <text-input
                      @change="handleChange"
                      :validator="validate"
                      :error-text="errorText"
                    />
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import textInput from '@/components/inputs/text';
import question from '@/components/ui/question';
import { mapGetters } from 'vuex'

export default {
  name: 'textInputItem',
  components: {
    question,
    textInput,
  },
  props: {
    item: {
      type: Object,
    },
    itemProperties: {
      type: Object,
    },
    interactionInstanceToken: {
      type: String,
    },
    productType: {
      type: String
    },
    minLength: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    ...mapGetters([
      'locales',
    ]),
    errorText() {
      return this.$t(`${this.item.text}_TEXT_VAL_ERROR`);
    },
    privacyPolicyLink() {
      const result = {};
      this.locales
        .filter(locale => !locale.hidden)
        .forEach(locale => {
          const langKey = locale.language.toLowerCase();
          const localeId = locale.id;

          result[`privacy_policy_link_${langKey}`] = `/i/${this.interactionInstanceToken}/privacy-policy?product=${this.productType}&locale=${localeId}`;
        });
      
      return result;
    },
  },
  methods: {
    handleChange(textInput) {
      if (textInput) {
        this.$emit('answer', {
          ...this.item,
          result: 1,
          data: [
            {
              key: 'TEXT',
              value: textInput,
            },
          ],
        });
      } else {
        this.$emit('answer', null);
      }
    },
    validate(input) {
      return input.length >= this.minLength;
    },
  },
};
</script>
